<script setup lang="ts">
import { computed } from 'vue'
import { PhList } from '@phosphor-icons/vue'
import { Button } from '@/components/ui/button'
import { useSidebar } from '@/components/ui/sidebar'

const { isMobile, open, openMobile, toggleSidebar } = useSidebar()

/** Sheet uses openMobile; desktop rail uses open — both drive visibility. */
const sidebarExpanded = computed(() =>
  isMobile.value ? openMobile.value : open.value,
)
</script>

<template>
  <Button
    variant="ghost"
    size="icon"
    @click="toggleSidebar"
    class="h-8 w-8"
    aria-label="Toggle navigation menu"
    :aria-expanded="sidebarExpanded"
  >
    <PhList :size="20" />
    <span class="sr-only">Toggle sidebar</span>
  </Button>
</template>